if (typeof(window.membershipProductButton) === 'undefined') {
  window.membershipProductButton = {
    initialized: false,
    removeOtherMemberships: async () => {
      // HACK: Remove all membership here (Disable if UPEZ is back)
      if (window.membership && window.membership.updateMembershipLineItems) {
        await window.membership.updateMembershipLineItems(null, [
          '43179795808446',
          '43179796529342',
          '43179796889790',
        ]);
      }
    },
    addToCart: async ($el) => {
      const $submit = $el;
      const productVariantId = $el.data('product-variant-id');
      const membershipVariantPlanId = $el.data('membership-variant-id');
      const membershipSellingPlanId = $el.data('membership-selling-plan-id');
      const membershipIsFree = $el.data('membership-free') ?? "0";
      const showLoading = $el.data('show-loading') ?? 0;
      const data = {
        items: [],
      };

      if ($submit.is(':disabled')) {
        return;
      }
      
      let originalText = $submit.html();
      $submit.attr('disabled', 'disabled');
      if (showLoading) {
        $submit.addClass('btn--loading');
      }

      if (window.sassy) {
        await window.sassy.cart.removeMembershipItems();
      }

      if (productVariantId) {
        data.items.push({
          id: productVariantId,
          quantity: 1,
        });
      }
      
      if (membershipVariantPlanId && membershipSellingPlanId) {
        data.items.push({
          id: membershipVariantPlanId,
          selling_plan: membershipSellingPlanId,
          quantity: 1,
          properties: {
            _Type: `Bundle`,
            _IsFree: membershipIsFree == 1 ? "Yes" : "No",
          }
        });
      }

      if (!data.items.length) {
        $submit.removeAttr('disabled');
        if (showLoading) {
          $submit.removeClass('btn--loading');
        }
        return;
      }
      
      fetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "xmlhttprequest",
        },
      }).then(() => {
        // Optional redirect to cart (Disable if UPEZ is back)
        // window.location.href = "/cart";
      }).finally(() => {
        $submit.removeAttr('disabled');
        if (showLoading) {
          $submit.removeClass('btn--loading');
        }
      });
    },
    init: () => {
      $(document).on('click', '[data-membership-product-trigger]', function(e) {
        e.preventDefault();
        window.membershipProductButton.addToCart($(this));
      })

      window.membershipProductButton.initialized = true;
    },
  };

  document.addEventListener("DOMContentLoaded", function () {
    window.membershipProductButton.init();
  });
}